import { contentAi } from '@mi-front/api-clients';
import { BtnLink, MrtTable } from '@mi-front/ui';
import { Info as InfoIcon } from '@mui/icons-material';
import { Box } from '@mui/material';
import { Row } from '@tanstack/react-table';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { ListingResultProps } from '../../../../core/reports/components/ListingView';
import { ListingType } from '../../../../core/reports/types';

/** Case-insensitive title filter for MRT global filter. */
function filterTitle(row: Row<unknown>, title: string, filterValue: string) {
  const value = row.getValue(title);
  if (typeof value === 'string') {
    return value.toLowerCase().includes(filterValue.toLowerCase());
  }

  return false;
}

export function ContentsList(
  p: ListingResultProps<ListingType<Record<string, never>, contentAi.ThinContentDto>>,
) {
  const { $t } = useIntl();

  return (
    <MrtTable
      {...p.mrtProps}
      enableGlobalFilter={true}
      filterFns={{
        titleFilterFn: filterTitle,
      }}
      globalFilterFn="titleFilterFn"
      columns={[
        {
          header: $t({
            id: 'common.createdAt',
            defaultMessage: 'Creado',
          }),
          size: 120,
          accessorKey: 'createdAt',
          Cell: ({ cell }) => new Date(cell.getValue()).toLocaleString(),
        },
        {
          header: $t({
            id: 'contentAi.contentsList.source',
            defaultMessage: 'Source',
          }),
          size: 250,
          Cell: ({ row }) => {
            const fragment = row.original.source.data.fragment!;

            if (fragment) {
              return (
                <Box>
                  <Box>
                    <small>
                      {$t({
                        id: 'contentAi.contentsList.fragment',
                        defaultMessage: 'Fragmento',
                      })}
                    </small>
                  </Box>
                  <Link to={`/fragments/${fragment.id}`}>{fragment.title}</Link>
                </Box>
              );
            }

            return '';
          },
        },
        {
          header: $t({
            id: 'common.actions',
            defaultMessage: 'Acciones',
          }),
          enableGlobalFilter: false,
          Cell: ({ row }) => {
            return (
              <BtnLink
                size="xs"
                type="outline-primary"
                icon={<InfoIcon />}
                to={`/content-ai/contents/${row.original.id}`}
              >
                {$t({
                  id: 'contentAi.contentsList.view',
                  defaultMessage: 'Ver',
                })}
              </BtnLink>
            );
          },
        },
      ]}
    />
  );
}
